import gql from 'graphql-tag'

// Note: MainFormAuth is used by refetch queries!
export const QUERY_MAIN_FORM_AUTH = gql`
	query mainFormAuth($formId: ID!, $recordId: ID!) {
		form(id: $formId) {
			id
			title
			publicLinkIsReadOnly
			publicLinkSubmitButtonText
			hidePublicLinkSubmitButton
			actionsFormat
			allowPublicLinks
			allowReset
			lockedFromFormAction(recordId: $recordId)
			hideControlPanel
			readOnly
			llmInterface {
				id
				rank
				llmResponseHtml(formId: $formId, recordId: $recordId) {
					id
					html
				}
			}
			llmInterfaceStyle
			infoBlocks {
				id
				title
				titleSize
				contentHtml
				rank
				hasPaddingBefore
				hasPaddingAfter
				conditionalOption {
					id
					label
					field {
						id
					}
				}
				metabaseDashboards {
					id
					name
				}
			}
			fields(orderBy: [{field: rank}]) {
				id
				rank
				title
				type
				subtitle
				contentType
				placeholder
				allowMultipleAnswers
				conditionalOption {
					id
					label
					field {
						id
					}
				}
				disabledAlways
				disableWhenPublic
				disableWhenSigning
				disableEditingRowsWhenPublic
				disabledForFormActions(recordId: $recordId) {
					id
					record {
						id
						name
					}
					form {
						id
						title
					}
				}
				llmMemory
				mandatory
				subsectionHeading
				hiddenFieldId(recordId: $recordId)
				placeholder
				canHide
				tableFields(orderBy: [{field: rank}]) {
					id
					title
					rank
					type
					disabledAlways
					disableWhenPublic
					disableWhenSigning
					placeholder
					helpInfo {
						id
						htmlContent
					}
					selectOptions {
						id
						label
						color
						order
					}
				}
				helpInfo {
					id
					htmlContent
				}
				selectOptions {
					id
					label
					color
					order
				}
			}
		}
		record(id: $recordId) {
			id
			name
			archived
			position
			team {
				id
				organisation {
					id
				}
			}
		}
		initialAnswer_List(record: $recordId, form: $formId) {
			objects {
				id
				fieldId
				tableFieldId
				rank
				contentText
				contentDate
				contentBoolean
				contentDecimal
				contentFile
				contentFileName
			}
		}
	}
`
